import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import "./PageHeader.css";

/**
 * Reusable page heading.
 *  title / description : text
 *  filters             : node rendered under the description (e.g. status chips)
 *  actions             : node on the right (search, selects, buttons) — stacks below on small screens
 */
const PageHeader = ({
  title,
  description,
  filters,
  actions,
  showBreadcrumbs = true,
}) => (
  <header className="page-header">
    <div className="page-header__main">
      {showBreadcrumbs && <Breadcrumbs />}
      <h2>{title}</h2>
      {description && <p>{description}</p>}
      {filters}
    </div>
    {actions && <div className="page-header__actions">{actions}</div>}
  </header>
);

export default PageHeader;
